<template>
    <!--父级路由和子级路由的选择-->
    <div class="shortcut-box" ref="scrollableDiv">
        <!-- 菜单栏 -->
        <div class="person-info">
            <div class="contact-me" id="contact">
                <!-- 搜索条件 -->
                <div class="text-center-row">
                    <div class="row">
                        <div class="form-group">
                            <div class="input-group" id="input-group">
                                <!-- 平台 -->
                                <el-select
                                    v-model="sourceSelect"
                                    placeholder="请选择平台"
                                    clearable
                                    class="custom-select"
                                    @change="sourceChange"
                                    multiple
                                    collapse-tags
                                    collapse-tags-tooltip>
                                    <template v-if="selectdata && selectdata.success">
                                        <el-option v-for="(items, index) in selectdata.data.sourcesList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 等级 -->
                                <el-select
                                    v-model="gradeSelect"
                                    placeholder="请选择等级"
                                    clearable
                                    class="custom-select collapse-tags"
                                    id="collapse-tags"
                                    multiple
                                    collapse-tags
                                    filterable>
                                    <template v-if="selectsource && selectsource.success">
                                        <el-option v-for="(items, index) in selectsource.data.gradeList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 品牌 -->
                                <el-select v-model="brandSelect" placeholder="请选择品牌" clearable class="custom-select" @change="brandChange" filterable>
                                    <template v-if="selectsource && selectsource.success">
                                        <el-option v-for="(items, index) in selectsource.data.brandList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 型号 -->
                                <el-select v-model="modelSelect" placeholder="请选择型号" clearable class="custom-select" @change="modelChange" filterable>
                                    <template v-if="selectbrand && selectbrand.success">
                                        <el-option v-for="(items, index) in selectbrand.data.modelList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 颜色 -->
                                <el-select v-model="colorSelect" placeholder="请选择颜色" clearable class="custom-select">
                                    <template v-if="selectbasicinfo && selectbasicinfo.success">
                                        <el-option v-for="(items, index) in selectbasicinfo.data.colorList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 容量 -->
                                <el-select v-model="capacitySelect" placeholder="请选择容量" clearable class="custom-select">
                                    <template v-if="selectbasicinfo && selectbasicinfo.success">
                                        <el-option v-for="(items, index) in selectbasicinfo.data.capacityList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 壳瑕疵 -->
                                <el-select v-model="shuckSelect" placeholder="请选择壳瑕疵" clearable class="custom-select" multiple>
                                    <template v-if="selectdata && selectdata.success">
                                        <el-option v-for="(items, index) in selectdata.data.shuckList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                                <!-- 屏瑕疵 -->
                                <el-select v-model="screenSelect" placeholder="请选择屏瑕疵" clearable class="custom-select">
                                    <template v-if="selectdata && selectdata.success">
                                        <el-option v-for="(items, index) in selectdata.data.screenList" :key="index" :label="items" :value="items"></el-option>
                                    </template>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 按钮栏 -->
                <div class="button">
                    <div style="display: flex; justify-content: space-between">
                        <div>
                            <button class="btn" @click="menuselect(patch)">查询</button>
                            <button class="btn" @click="resetSelection()">重选</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 数据展示 -->
        <section class="section">
            <div v-if="sisadmin">
                <input type="text" v-model="wwe" placeholder="批次号查询,如20240730_2" />
                <button @click="test(wwe)">测试</button>{{ wwe }}
            </div>
            <!-- 分页控件 -->
            <!-- todo 将分页控件放在 页尾 -->
            <el-pagination
                v-model:currentPage="currentPage"
                v-model:page-size="itemsPerPage"
                :page-sizes="[1, 20, 40, 60, 80]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allitems"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="display: flex; justify-content: center; margin-top: 20px" />
            <div v-if="error" class="error-message">{{ error }}</div>

            <!-- 数据 -->
            <div v-if="data">
                <!-- 获取到数据 -->
                <div v-if="data.success">
                    <div v-if="data.data.result && data.data.result.length > 0">
                        <!-- 弹窗 -->
                        <div>
                            <div class="cartover" id="cartover" @click="closePopup()">
                                <div class="scorllpop" @click.stop>
                                    <span class="close-btn" @click="closePopup()" style="color: black; background-color: #babebf">关闭X</span>
                                    <detailsCardView
                                        ref="detailsCardView"
                                        @call-closePopup="closePopup()"
                                        @callParentMethod="handleCallFromChild"
                                        :orderAccountList="orderAccountList"
                                        :isFlag="isFlag"
                                        :pjtNewPrice="pjtNewPrice">
                                    </detailsCardView>
                                </div>
                            </div>
                        </div>
                        <!-- 列表 -->
                        <div v-for="(item, index) in data.data.result" :key="index" class="item" v-loading="loading">
                            <ul class="services" style="position: relative">
                                <li class="services__item" :class="{ selected: selectedIndex === index }" @click="selectItem(item, index)">
                                    <div style="display: flex">
                                        <div>
                                            <!-- 标题 -->
                                            <h3 style="display: flex; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                                <!-- 等级 -->
                                                <span class="pgrade">
                                                    {{ item.grade }}
                                                </span>
                                                <!-- 起拍价 -->
                                                <span class="pprice">¥{{ item.upsetPrice }}</span>
                                                <div>
                                                    <span style="font-size: 12px; vertical-align: bottom; margin-bottom: 0; padding-bottom: 0; margin-right: 9px"> 起拍 </span>
                                                </div>
                                                <!-- 其他信息 -->
                                                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                                    {{ item.model }}
                                                    <span v-if="item.ram" style="margin-left: 8px">{{ item.ram }}+ </span>
                                                    {{ item.storage }}
                                                    {{ item.color }}
                                                </div>
                                            </h3>

                                            <!-- 标签 -->
                                            <div style="display: flex; width: 100%; justify-content: space-between">
                                                <p style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                                                    <!-- 商家 -->
                                                    <span
                                                        v-if="item.authorization"
                                                        class="yy"
                                                        style="background-color: red; border-radius: 4px; margin-left: 6px; padding: 2px; color: white">
                                                        {{ item.authorization }}
                                                    </span>
                                                    <!-- 渠道 -->
                                                    <span
                                                        v-if="item.purchaseChannel"
                                                        class="yy"
                                                        style="background-color: green; border-radius: 4px; margin-left: 6px; padding: 2px; color: white">
                                                        {{ item.purchaseChannel }}
                                                    </span>
                                                    <!-- 占位符 -->
                                                    <span class="yy" style="background-color: #00000000; border-radius: 4px; margin-left: 6px; padding: 2px; color: #00000000">
                                                        .
                                                    </span>
                                                </p>
                                            </div>

                                            <div
                                                style="
                                                    display: -webkit-box;
                                                    -webkit-line-clamp: 2;
                                                    line-clamp: 2;
                                                    -webkit-box-orient: vertical;
                                                    overflow: hidden;
                                                    text-overflow: ellipsis;
                                                    height: 3em; /* 根据行高设置合适的高度 */
                                                    line-height: 1.5em; /* 设置行高 */
                                                ">
                                                {{ parseQualityDesc(item.qualityDesc) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="imglogo">
                                        <!-- 图片logo显示 -->
                                        <img v-if="item.sources == '采货侠'" class="profile-img" src="@/assets/images/chx.png" alt="" />
                                        <img v-else-if="item.sources == '回收宝'" class="profile-img" src="@/assets/images/hsb.jpg" alt="" />
                                        <img v-else-if="item.sources == '小当竞拍'" class="profile-img" src="@/assets/images/xd.png" alt="" />
                                        <img v-else-if="item.sources == '拍机堂'" class="profile-img" src="@/assets/images/pjt.png" alt="" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- 上下页 -->
                        <div class="pagination">
                            <nav v-if="allitems >= 1">
                                <ul class="pagination">
                                    <!-- 上一页按钮 -->
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="#" @click.prevent="prevPage()">上一页</a>
                                    </li>
                                    <!-- 下一页按钮 -->
                                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                        <a class="page-link" href="#" @click.prevent="nextPage()"> 下一页 </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <!-- 错误提示 -->
                <div v-else>
                    <p class="error-message">获取数据失败: {{ data }}</p>
                </div>
            </div>
        </section>
        <FixedButtons @scroll-to-top="scrollToTop" />
    </div>
</template>

<script>
    import detailsCardView from "@/components/detailsCardView.vue";
    import FixedButtons from "@/components/FixedButtons.vue";
    import { changeToPath } from "@/utils/utils";
    import axios from "axios";
    import qs from "qs";
    import { mapActions, mapGetters } from "vuex";

    export default {
        components: { detailsCardView, FixedButtons },
        data() {
            return {
                sisadmin: localStorage.authRoleVOList.includes("管理员"),
                testshow: process.env.VUE_APP_SHOW,
                // sendtoZZevasURL: "/api/systemEvaluatePrice/sendZZEvaluatePrice",
                sendtoZZevasURL: "/api/systemEvaluatePrice/queryByPage",
                // goestimatedURL: "/api/productEvaluateResult/sendProductEvaluateInfo",
                goestimatedURL: "/api/PjtEvaluateDesc/sendAndRefreshEvaluatePriceByParam",
                accountURL: "/api/externalAccount/queryExternalAccount",
                orderByURL: "/api/externalAccount/queryOrderExternalAccount",
                warepriceURL: "/api/warePrice/queryWarePrice",
                optioniniURL: "/api/warePrice/init",
                wwe: "",
                ttkss: localStorage.nickname,
                switchView: false,
                selectedIndex: -1,
                // 下拉框数据
                conditons: ["开发中,成色不可用"],

                isOpen: false,

                // ???
                item: "",
                data: null,
                error: null,

                currentPage: 1, // 当前页码
                itemsPerPage: 20, // 每页显示条目数
                maxVisiblePages: 5, // 最多显示的页码数量
                gotoPageNumber: 1, // 用来存储用户输入的页码
                allitems: 1, // 总数据条数
                allpages: 1, // 总页数
                datatogo: "", // 要向vuex传递的数据

                // 下拉框的备选值
                selectdata: null,
                selectsource: null,
                selectbrand: null,
                selectmodel: null,
                selectbasicinfo: null,

                // 下拉框的选定值
                sourceSelect: null,
                gradeSelect: null,
                screenSelect: "",
                shuckSelect: null,

                brandSelect: null,
                modelSelect: null,
                colorSelect: null,
                capacitySelect: null,
                conditonSelect: null,

                // 右侧滚轮
                scrollableDiv: null,
                orderAccountList: [], // 下单账号
                loading: false,
                pjtNewPrice: "", //拍机堂价格
                timer: "",
                isFlag: false,
            };
        },
        watch: {
            // 当每页展示条目数量改变时，重新计算总页数并更新当前页码
            itemsPerPage() {
                // 返回第一页
                this.currentPage = 1;
                // 重新从服务器获取数据等
                this.menuselect();
            },
        },
        computed: {
            ...mapGetters("shared", ["getSharedData"]),
            sharedData() {
                return this.getSharedData;
            },
            satoken() {
                return this.$store.getters.getSatoken;
            },

            // 计算总页数
            totalPages() {
                return this.allpages;
            },

            // 根据当前页码和可见页码范围计算当前显示的页码数组
            visiblePages() {
                const pages = [];
                const totalPageCount = this.totalPages;
                const maxPages = this.maxVisiblePages;
                const currentPage = this.currentPage;

                if (totalPageCount <= maxPages) {
                    for (let i = 1; i <= totalPageCount; i++) {
                        pages.push(i);
                    }
                } else {
                    let left = Math.max(1, currentPage - Math.floor(maxPages / 2));
                    let right = Math.min(totalPageCount, left + maxPages - 1);

                    if (right - left + 1 < maxPages) {
                        left = Math.max(1, right - maxPages + 1);
                    }

                    for (let i = left; i <= right; i++) {
                        pages.push(i);
                    }

                    if (left > 1) {
                        pages.unshift("...");
                        pages.unshift(1);
                    }
                    if (right < totalPageCount) {
                        pages.push("...");
                        pages.push(totalPageCount);
                    }
                }

                return pages;
            },

            // 时间函数
            wwe2() {
                const date = new Date();
                this.time = this.zeroPadding(date.getHours(), 2) + ":" + this.zeroPadding(date.getMinutes(), 2) + ":" + this.zeroPadding(date.getSeconds(), 2);
                this.date = this.zeroPadding(date.getFullYear(), 4) + "-" + this.zeroPadding(date.getMonth() + 1, 2) + "-" + this.zeroPadding(date.getDate(), 2);
                if (date.getMinutes() < 50 && date.getHours() <= 8) {
                    return this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate() - 2, 2) + "_2";
                } else {
                    return this.zeroPadding(date.getFullYear(), 4) + this.zeroPadding(date.getMonth() + 1, 2) + this.zeroPadding(date.getDate() - 1, 2) + "_2";
                }
            },
        },
        mounted() {
            this.wwe = this.wwe2;
            // 需要回到顶部的div
            this.scrollableDiv = this.$refs.scrollableDiv;

            // this.wwe = "20241024_2";
        },
        created() {
            this.getinitData();
        },
        // 进入页面时就获取数据
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getinitData();
            });
        },
        methods: {
            ...mapActions("shared", ["updateSharedData", "updateCanbuyData"]),
            handleCallFromChild(data) {
                this.pjtNewPrice = data;
            },
            // 切换到 Beta 视图
            betaView() {
                changeToPath(this.$router, "/phones/usercard");
            },

            //获取下单账号
            getOrderAccount(item) {
                axios
                    .get(this.accountURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {})
                    .catch((error) => {})
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 页面置顶
            scrollToTop() {
                this.scrollableDiv.scrollIntoView({
                    top: 0,
                    behavior: "auto",
                });
            },

            // 下拉框显隐
            toggleOptions(selectId) {
                if (this.isOpen) {
                    this.isOpen = this.isOpen === selectId ? null : selectId;
                } else {
                    this.isOpen = selectId;
                }
            },
            // 选择平台获取品牌和等级数据
            sourceChange() {
                if (this.sourceSelect) {
                    this.setbrand();
                }
            },
            // 选择品牌获取型号
            brandChange() {
                if (this.sourceSelect && this.brandSelect) {
                    this.setmodel();
                }
            },
            // 选完 型号 后才有 其他基本信息
            modelChange() {
                if (this.sourceSelect && this.brandSelect && this.modelSelect) {
                    this.setbasicinfo();
                }
            },

            // 选择选项
            selectOption(option, selectId) {
                if (selectId === "select1") {
                    // 选择平台
                    this.sourceSelect = option;
                    // 选完来源后才有品牌&等级
                    this.setbrand();
                } else if (selectId === "select2") {
                    // 选择等级
                    // this.gradeSelect = option;
                    if (this.gradeSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.gradeSelect = this.gradeSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.gradeSelect.push(option);
                    }
                } else if (selectId === "select3") {
                    this.brandSelect = option;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = option;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.colorSelect = option;
                } else if (selectId === "select6") {
                    this.capacitySelect = option;
                } else if (selectId === "select7") {
                    this.conditonSelect = option;
                } else if (selectId === "select8") {
                    if (this.shuckSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.shuckSelect = this.shuckSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.shuckSelect.push(option);
                    }
                } else if (selectId === "select9") {
                    if (this.screenSelect.includes(option)) {
                        // 如果选项已经存在，移除它
                        this.screenSelect = this.screenSelect.filter((item) => item !== option);
                    } else {
                        // 如果选项不存在，添加它
                        this.screenSelect.push(option);
                    }
                }

                // 多选悬停
                if (selectId !== "select2" && selectId !== "select8" && selectId !== "select9") {
                    this.isOpen = null;
                }
            },
            // 全选
            allselect(selectId) {
                if (selectId === "select1") {
                    this.sourceSelect = null;
                    this.isOpen = null;
                } else if (selectId === "select2") {
                    this.gradeSelect = [];
                    this.isOpen = null;
                } else if (selectId === "select3") {
                    this.brandSelect = null;
                    this.isOpen = null;
                    // 选完 品牌 后才有 型号
                    this.setmodel();
                } else if (selectId === "select4") {
                    this.modelSelect = null;
                    this.isOpen = null;
                    // 选完 型号 后才有 其他基本信息
                    this.setbasicinfo();
                } else if (selectId === "select5") {
                    this.isOpen = null;
                    this.colorSelect = null;
                } else if (selectId === "select6") {
                    this.isOpen = null;
                    this.capacitySelect = null;
                } else if (selectId === "select7") {
                    this.isOpen = null;
                    this.conditonSelect = null;
                } else if (selectId === "select8") {
                    this.isOpen = null;
                    this.shuckSelect = [];
                } else if (selectId === "select9") {
                    this.isOpen = null;
                    this.screenSelect = [];
                }
            },

            // 打开详情页
            openPopup() {
                document.getElementById("cartover").style.display = "block";
            },
            // 关闭弹窗
            closePopup() {
                if (this.$refs.detailsCardView) {
                    // 在调用之前检查 selectTab 方法是否存在
                    if (typeof this.$refs.detailsCardView.selectTab === "function") {
                        this.$refs.detailsCardView.selectTab(1);
                    } else {
                        console.error("子组件中未定义 selectTab 方法");
                        return;
                    }
                } else {
                    console.error("子组件引用尚未可用");
                    return;
                }
                document.getElementById("cartover").style.display = "none";
            },

            // 选中列表--显示弹窗
            selectItem(item, index) {
                this.selectedIndex = index;
                // 向vuex传递数据
                this.updateSharedData(item);
                this.updateCanbuyData(true);
                // 显示弹窗
                this.openPopup();
                this.isFlag = true;
                // 发送估价请求 -- 拍机堂
                axios
                    .post(
                        this.goestimatedURL,
                        { id: item.id },
                        // { id: 43592},
                        {
                            headers: {
                                satoken: localStorage.sa,
                            },
                        }
                    )
                    .then((res) => {
                        this.isFlag = false;
                        this.pjtNewPrice = res.data.data.pjtPrice;
                        this.conditionnewPre = res.data.data.condition;
                    });
                // 发送估价请求 -- 转转

                axios
                    // .post(
                    //     `${this.sendtoZZevasURL}?id=${item.id}`,
                    //     {},
                    //     {
                    //         headers: {
                    //             satoken: localStorage.sa,
                    //         },
                    //     }
                    // )
                    .get(this.sendtoZZevasURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            id: item.id,
                            requestType: "refresh",
                        },
                    })
                    .then((res) => {});
                // 获取历史出价
                axios
                    .get(this.orderByURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: item.sources,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((res) => {
                        this.orderAccountList = res.data.data;
                    });
            },
            // 下面是页面跳转逻辑
            // 跳转到指定页码
            gotoPage(page = this.page, patch = this.patch) {
                if (page === "...") return;
                if (page >= 1 && page <= this.totalPages) {
                    this.currentPage = page;
                    axios
                        .get(this.warepriceURL, {
                            headers: {
                                satoken: localStorage.sa,
                            },
                            params: {
                                sources: this.sourceSelect,
                                brand: this.brandSelect,
                                model: this.modelSelect,
                                color: this.colorSelect,
                                grade: this.gradeSelect,
                                capacity: this.capacitySelect,
                                patch: patch,
                                pageNo: this.currentPage,
                                pageSize: this.itemsPerPage,
                                multiplecate: false,

                                // authorization: "转转个人"
                            },
                            paramsSerializer: (params) => {
                                return qs.stringify(params, { indices: false });
                            },
                        })
                        .then((response) => {
                            this.loading = false;
                            this.data = response.data;
                            this.allitems = response.data.data.total;
                            this.allpages = response.data.data.totalPages;
                        })
                        .catch((error) => {
                            this.data = error;
                        });
                }
            },
            // 上一页
            prevPage() {
                if (this.currentPage > 1) {
                    this.loading = true;
                    this.currentPage--;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },
            // 下一页
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.loading = true;
                    this.currentPage++;
                    this.gotoPage(this.currentPage);
                    this.scrollToTop();
                }
            },

            // 初始化筛选条件
            getselectData(patch = this.patch) {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectdata = response.data;
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },
            // 清除品牌
            clearbrand() {
                this.brandSelect = null;
                this.resetbrand();
            },
            // 重选品牌
            resetbrand() {
                this.modelSelect = null;
                this.colorSelect = null;
                this.capacitySelect = null;
            },
            // 重置筛选条件
            resetSelection() {
                this.sourceSelect = null;

                this.clearbrand();
                this.gradeSelect = [];
                this.screenSelect = "";
                this.shuckSelect = [];

                this.conditonSelect = null;

                this.selectbrand = null;
                this.selectmodel = null;
                this.selectbasicinfo = null;
            },
            // 根据平台展示品牌
            setbrand() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectsource = response.data;
                        this.clearbrand();
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },
            // 根据品牌展示型号
            setmodel() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            gradeSelect: this.gradeSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectbrand = response.data;
                        this.resetbrand();
                    })
                    .catch((error) => {
                        this.selectdata = error;
                    });
            },

            // 根据 型号展示基本信息
            setbasicinfo() {
                axios
                    .get(this.optioniniURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            gradeSelect: this.gradeSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            patch: this.patch,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.selectbasicinfo = response.data;
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 初始化采货列表
            ...mapGetters("auth", ["getLoginData"]),
            getinitData(patch = this.patch) {
                if (this.getLoginData()) {
                    sa = "zhenzhi " + this.getLoginData().saTokenInfo.tokenValue;
                    localStorage.setItem("sa", sa);
                } else {
                    var sa = localStorage.sa;
                }
                // patch 只在暗拍间隙生效
                delete this.patch;
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                            pageNo: this.pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.getselectData();
                        this.allitems = response.data.data.total;
                        this.allpages = response.data.data.totalPages;
                        this.resetSelection();
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 按照条件筛选出采货数据
            menuselect(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            color: this.colorSelect,
                            grade: this.gradeSelect,
                            capacity: this.capacitySelect,
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            shuck: this.shuckSelect,
                            screen: this.screenSelect,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.currentPage = 1;
                        this.allitems = response.data.data.total;
                        this.allpages = response.data.data.totalPages;
                        if (this.data.data.total === 0) {
                            //
                        }
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            menuselect2(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            sources: this.sourceSelect,
                            brand: this.brandSelect,
                            model: this.modelSelect,
                            color: this.colorSelect,
                            grade: this.gradeSelect,
                            capacity: this.capacitySelect,
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.allitems = response.data.data.total;
                        this.allpages = response.data.data.totalPages;
                        if (this.data.data.total === 0) {
                            //
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },

            // 测试采货数据
            test(patch = this.patch, pageNo = 1) {
                // patch 只在暗拍间隙生效
                axios
                    .get(this.warepriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: patch,
                            pageNo: pageNo,
                            pageSize: this.itemsPerPage,
                            multiplecate: false,

                            // authorization: "转转个人"
                        },
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { indices: false });
                        },
                    })
                    .then((response) => {
                        this.data = response.data;
                        this.patch = patch;
                        this.getselectData(patch);
                        this.allitems = response.data.data.total;
                        this.allpages = response.data.data.totalPages;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    });
            },
            // 处理 \"
            parseDefectUrls(defectUrl) {
                try {
                    const urls = JSON.parse(defectUrl);
                    return Object.values(urls);
                } catch (e) {
                    return [];
                }
            },
            // 处理 \"
            parseQualityDesc(desc) {
                try {
                    const quality = JSON.parse(desc);
                    let result = "";
                    for (let key in quality) {
                        result += `■ ${key}: ${quality[key]} `;
                    }
                    return result.trim();
                } catch (e) {
                    return desc;
                }
            },

            // 时间格式化
            zeroPadding(num, digit) {
                let zero = "";
                for (let i = 0; i < digit; i++) {
                    zero += "0";
                }
                return (zero + num).slice(-digit);
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.menuselect2();
            },

            //改变页数
            handleCurrentChange(val) {
                this.loading = true;
                this.pageNo = val;
                this.gotoPage(val);
            },
        },
    };
</script>

<style lang="scss" scoped>
    // 下面是自定义下拉框样式
    /* CSS样式 */
    :deep(#contact .el-icon) {
        // margin-top: 30px;
        margin-right: 10px;
    }

    :deep() {
        .el-switch__label {
            &.is-active {
                color: rgb(255, 255, 255);
            }
        }
    }

    .section {
        position: relative;
    }

    :deep(.section .icon_pop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: 118px;
        left: 240px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    .custom-select {
        // 显示出滚动条
        position: relative;
        width: 200px;
        /* 调整选择框的宽度 */
        margin-right: 20px;
    }

    .custom-select input {
        display: flex;
        width: 100%;
        padding: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        background-color: #fff;
    }

    .custom-select .options {
        // 绝对展示--不干扰其他元素位置
        position: absolute;
        display: none;
        width: 100%;
        /* 调整下拉选项的最大高度 */
        max-height: 290px;
        overflow-y: auto;
        border: 1px solid #ccc;
        background-color: #fff;
        z-index: 9002;
    }

    .custom-select .option {
        display: flex;
        /* 允许换行 */
        white-space: normal;
        /* 选项文字不换行*/
        white-space: nowrap;
        /* 长单词换行 */
        //word-wrap: break-word;
        color: #204d74;
        cursor: pointer;
    }

    // 搜索菜单选中
    .custom-select .option.selected {
        background-color: #007bff;
        color: white;
    }

    .custom-select .option.selected:hover {
        background-color: #007bff;
        color: white;
    }

    // 搜索菜单划过
    .custom-select .option:hover {
        background-color: #f0f0f0;
    }

    .custom-select.open .options {
        display: block;
    }

    // 上面是自定义下拉框样式

    /* CSS 样式，用于弹窗外观 */
    .cartover {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* 半透明黑色背景 */
        z-index: 9999;
        /* 弹窗位于最上层 */
    }

    .scorllpop {
        overflow: auto;
        position: fixed;
        background-color: white;
        height: 100%;
        width: 70%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px rgb(12, 28, 248);
        /*	text-align: center;	*/
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        /* 确保弹窗在黑色背景之上 */
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }

    // MIXINS
    @mixin bp-sm {
        @media (min-width: 40.625em) {
            @content;
        }
    }

    @mixin bp-md {
        @media (min-width: 48em) {
            @content;
        }
    }

    @mixin bp-lg {
        @media (min-width: 62em) {
            @content;
        }
    }

    @mixin pseudo-starter {
        content: "";
        display: block;
    }

    .shortcut-box {
        width: 100%;
        // 悬停样式变化
        transition: all 300ms ease, transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);

        // 页面颜色
        --color-brand-primary: hsl(var(--color-brand-primary-h), 43%, 43%);
        --color-brand-primary-h: 251;
        --color-brand-primary-s: 43%;
        --color-brand-primary-l: 43%;
        --color-brand-accent: hsl(var(--color-brand-accent-h), 96%, 61%);
        --color-brand-accent-h: 16;
        --color-brand-accent-s: 96%;
        --color-brand-accent-l: 61%;
        --color-brand-accent-bg: hsl(calc(var(--color-brand-accent-h) + 17), 100%, 96%);

        // 页面排列（排版）
        // The ratio number
        --ratio: 1.4;

        //小尺寸
        --s-6: calc(var(--s-5) / var(--ratio));
        --s-5: calc(var(--s-4) / var(--ratio));
        --s-4: calc(var(--s-3) / var(--ratio));
        --s-3: calc(var(--s-2) / var(--ratio));
        --s-2: calc(var(--s-1) / var(--ratio));
        --s-1: calc(var(--s0) / var(--ratio));
        --s0: calc(1.05rem + 0.333vw);

        // 大尺寸
        --s1: calc(var(--s0) * var(--ratio));
        --s2: calc(var(--s1) * var(--ratio));
        --s3: calc(var(--s2) * var(--ratio));
        --s4: calc(var(--s3) * var(--ratio));
        --s5: calc(var(--s4) * var(--ratio));
        --s6: calc(var(--s5) * var(--ratio));
        box-sizing: border-box;

        line-height: 1.6;

        overflow-x: hidden;

        @include bp-sm {
            --s0: calc(1.25rem + 0.333vw);
        }

        @include bp-md {
            --s0: calc(1.4rem + 0.333vw);
        }

        @include bp-lg {
            --s0: calc(0.9rem + 0.333vw);
        }
    }

    .section {
        padding: 20px 0;

        .header {
            height: 165px;
            z-index: -1;
            background-attachment: fixed;
        }
    }

    h2,
    h3,
    p,
    ul {
        margin: 0;
    }

    // 展示数据样式
    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 8px;
        }
    }

    .services {
        grid-gap: var(--s2);
        margin: 0 calc(var(--s3) * -1);
        padding: var(--s6) var(--s3);
        position: relative;
        z-index: 1;

        @include bp-sm {
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: minmax(100px, 1fr);
        }

        @include bp-sm {
            padding: 0 var(--s3);
        }

        &__item {
            background: #fff;
            padding: calc(var(--s0) - 0.6rem) var(--s3);
            border-radius: 15px;
            margin-top: 12px;

            h3 {
                color: var(--color-brand-primary);
                font-size: var(--s1);
                line-height: 1.2;
            }

            &:after {
                @include pseudo-starter;
                position: absolute;
                top: 0;
                left: 0;
                width: 50px;
                height: 50px;
                border-radius: 15px 0;
                cursor: pointer;
                transition: inherit;
                background-color: var(--color-brand-accent);
                background-size: 20px 20px;
                background-repeat: no-repeat;
                background-position: center;
            }

            img {
                border-radius: 15px 0;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 50px;
                height: 50px;
                z-index: 99999;
            }

            p {
                margin-top: var(--s-1);
                font-weight: 400;
                color: hsl(250deg, 7%, 46%);
            }
        }
    }

    // 搜索菜单栏样式
    .person-info {
        width: 100%;
        overflow: visible;
        align-items: center;
        //background-color: rgba(16 18 27 / 10%);
        color: #ffffff;
        // border-bottom: 1px solid white;

        .contact-me {
            // display: flex;
            flex-direction: column;
            width: 100%;
            overflow: visible;

            .text-center-row {
                // display: flex;
                flex-wrap: wrap;
                width: 100%;

                .row {
                    .form-group {
                        .input-group {
                            display: flex;
                            flex-direction: row;
                            padding-right: 20px;
                            height: 38px;
                            width: 100%;
                            margin-bottom: 10px;
                        }
                    }

                    .input {
                        width: 100%;
                        margin-right: 30px;
                        border-radius: 2px;
                        border: 1px solid #ccc;
                    }

                    .input1 {
                        padding: 10px;
                        border-radius: 4px;
                    }

                    .input:focus {
                        border-color: #66afe9;
                        outline: 0;
                        box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
                    }

                    @media screen and (max-width: 1110px) {
                        width: 100%;
                    }
                }
            }

            .button {
                .btn {
                    padding: 8px 30px;
                    border-radius: 6px;
                    background-color: #007bff;
                    border-color: #2e6da4;
                    color: #ffffff;
                    font-weight: 500;
                    margin-right: 20px;
                }

                .btn:hover {
                    background-color: #0056b3;
                    border-color: #204d74;
                }
            }
        }
    }

    /* 分页样式 下面 */
    .pagination {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .pagination ul {
        display: flex;
        list-style-type: none;
        padding: 0;
    }

    .pagination ul li {
        margin: 0 5px;
    }

    .pagination ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .pagination ul li.page-item a {
        text-decoration: none;
        padding: 5px 10px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: #f5f5f5;
    }

    .pagination ul li.page-item a:hover {
        background-color: #e9ecef;
    }

    .pagination ul li.page-item.active a {
        background-color: #007bff;
        color: white;
    }

    /* 可选：自定义分页样式 上面 */

    // 数据列表
    .services__item {
        position: relative;

        .pgrade {
            display: flex;
            background-color: rgb(250, 216, 27);
            padding-right: 4px;
            width: 65px;
            text-align: center;
            justify-content: center;
            border-radius: 4px;
            margin-right: 9px;
        }

        .pprice {
            color: rgb(244, 108, 68);
        }
    }

    .services__item.selected {
        background-color: var(--color-brand-accent);

        h3 {
            color: #fff;

            .pgrade {
                display: flex;
                padding-right: 4px;
                width: 65px;
                text-align: center;
                justify-content: center;
                border-radius: 4px;
                margin-right: 9px;
            }
        }

        p {
            color: hsla(0, 0%, 100%, 0.8);

            .yy {
                color: #201e1e;
            }
        }

        .pprice {
            color: rgb(31, 27, 26);
        }

        :deep(.custom-collapse .el-select__wrapper.is-filterable) {
            height: 38px !important;
        }
    }
</style>
